import React, { useState } from 'react'
import {
    Typography,
    Button,
    DialogActions,
    DialogContent,
    Input,
} from '@material-ui/core'
import EditableDialogWrapper from './editableDialogWrapper'
import PropTypes from 'prop-types'

const FreetypeDialog = ({
    title,
    description,
    open,
    onConfirm,
    onReset,
    onClose,
    currentValue,
    onChange,
    resetButtonVisible = true,
    confirmButtonText,
}) => {
    const [content, setContent] = useState(currentValue)
    return (
        <EditableDialogWrapper title={title} open={open} onClose={onClose}>
            <DialogContent dividers>
                {description && (
                    <Typography gutterBottom>{description}</Typography>
                )}
                <Input
                    defaultValue={
                        content.trim() === title.trim() ? '' : content
                    }
                    onChange={e => {
                        onChange(e.target.value)
                        setContent(e.target.value)
                    }}
                    placeholder={title}
                />
            </DialogContent>
            <DialogActions>
                {resetButtonVisible && (
                    <Button onClick={() => onReset(title)} color='secondary'>
                        Reset
                    </Button>
                )}
                <Button
                    variant='contained'
                    onClick={() => onConfirm(content)}
                    color='secondary'
                >
                    {confirmButtonText || 'Confirm'}
                </Button>
            </DialogActions>
        </EditableDialogWrapper>
    )
}
FreetypeDialog.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    currentValue: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    resetButtonVisible: PropTypes.bool,
    confirmButtonText: PropTypes.string,
}

export default FreetypeDialog
